import isNil from 'lodash/isNil';
import {
  ContinueInfo,
  Maybe,
  Preview,
} from '../../../../graphql/generated/types';

export function getShouldShowPreviewTab({
  isMobile,
  preview,
  pageContinue,
}: {
  isMobile: boolean;
  preview?: Maybe<Preview>;
  pageContinue?: Maybe<ContinueInfo>;
}) {
  return (
    isMobile &&
    !isNil(preview?.item?.productId) &&
    isNil(pageContinue?.lastReadProductId)
  );
}
